import { render, staticRenderFns } from "./bar-order-constructor-order.vue?vue&type=template&id=690b48f1&"
import script from "./bar-order-constructor-order.vue?vue&type=script&lang=ts&"
export * from "./bar-order-constructor-order.vue?vue&type=script&lang=ts&"
import style0 from "./bar-order-constructor-order.vue?vue&type=style&index=0&id=690b48f1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports